export const ALPHA_NUMERIC_DASH_UNDERSCORE_PATTERN = /^\s*[a-zA-Z0-9\-_]+\s*$/;


export const ALPHA_NUMERIC_DASH_UNDERSCORE_ALLOW_SPACES_AT_START_END_PATTERN = /^\s*[a-zA-Z0-9-]*\s*$/;
